import React from "react";
import ScrollOverPack from "rc-scroll-anim/lib/ScrollOverPack";
import QueueAnim from "rc-queue-anim";
import "rc-texty/assets/index.css";
import { Card, Col, Row } from "antd";
import "./index.less";
import classNames from "classnames";

export default class content extends React.Component {
  state = {
    show: true,
    showP4: true,
  };

  getChildrenToRender = (list) => {
    const style1 = { color: "#008ad6", fontfamily: "SimSun", marginBottom: 0 };
    const style2 = { color: "#fff", fontfamily: "SimSun" };
    return list.map((i, index) => {
      return (
        <Col
          className="gutter-row word-line"
          xs={24}
          sm={24}
          md={8}
          lg={8}
          xl={8}
          key={index}
        >
          <div className="h1" style={style1}>
            {i.title}
          </div>
          <div className="p" style={style2}>
            {i.disc}
          </div>
        </Col>
      );
    });
  };

  render() {
    const cardStyle = {
      width: 500,
      padding: 8,
      margin: "0px auto 0 auto",
      border: "none",
      background: "transparent",
    };
    const list4 = [
      {
        title: "1800KHz",
        disc: "最高扫描频率",
      },
      {
        title: "1400m",
        disc: "最大扫描距离",
      },
      {
        title: "2.1亿",
        disc: "图像总像素",
      },
    ];
    const list6 = [
      {
        title: "100KHz",
        disc: "最高扫描频率",
      },
      {
        title: "500m",
        disc: "最大扫描距离",
      },
      {
        title: "1.2亿",
        disc: "图像总像素",
      },
    ];
    const childrenToRender = this.state.showP4
      ? this.getChildrenToRender(list4)
      : this.getChildrenToRender(list6);
    return (
      <ScrollOverPack id="craft" className="allElements-content">
        <div
          style={{
            display: "flex",
            "justify-content": "space-around",
          }}
        >
          <Card
            hoverable
            cover={
              <img
                alt="example"
                src="https://qiniu.metridynamic.com/image%2FallElements%2Fv2_rfyt5l.png"
              />
            }
            style={cardStyle}
            onMouseEnter={() => {
              this.setState({
                showP4: true,
              });
            }}
          ></Card>
          <Card
            hoverable
            cover={
              <img
                alt="example"
                src="https://qiniu.metridynamic.com/image%2FallElements%2Fv2_rfyt26.png"
              />
            }
            style={cardStyle}
            onMouseEnter={() => {
              this.setState({
                showP4: false,
              });
            }}
          ></Card>
        </div>
        <div className="btn">
          <div
            className={classNames("btn1", {
              "btn1-active": this.state.showP4,
            })}
            onClick={() => {
              this.setState({
                showP4: true,
              });
            }}
          >
            RM140
          </div>
          <div
            className={classNames("btn2", {
              "btn2-active": !this.state.showP4,
            })}
            onClick={() => {
              this.setState({
                showP4: false,
              });
            }}
          >
            RM30
          </div>
        </div>
        <QueueAnim
          className="text-wrapper-bottom"
          key="text"
          duration={1450}
          type="left"
          leaveReverse
        >
          <Row gutter={[16, 24]} key="a" style={{ margin: 0 }}>
            {childrenToRender}
          </Row>
        </QueueAnim>
      </ScrollOverPack>
    );
  }
}
